var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.691,
    height: 57.965,
    viewBox: "0 0 51.691 57.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2986",
    "data-name": "Group 2986",
    transform: "translate(-113.622 -162.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M120.468,174.093c.627,1.091,1.2,2.115,1.8,3.128a4.851,4.851,0,0,1-2.848,7.189c-1.028.3-2.063.578-3.1.822-.416.1-.524.291-.52.693.019,1.7.008,3.405.008,5.108v.721h-1.85c0-.2,0-.4,0-.6,0-1.85,0-3.7,0-5.549a1.887,1.887,0,0,1,1.618-2.079c1.052-.29,2.109-.561,3.162-.849a2.993,2.993,0,0,0,1.891-4.563c-.549-.969-1.12-1.925-1.665-2.9a1.927,1.927,0,0,1,.34-2.575q2.129-2.151,4.28-4.281a1.884,1.884,0,0,1,2.52-.334c1.025.576,2.025,1.2,3.061,1.753a2.952,2.952,0,0,0,4.389-1.876c.308-1.068.586-2.146.868-3.221a1.965,1.965,0,0,1,2.122-1.664q3-.007,5.991,0a1.91,1.91,0,0,1,2.065,1.564c.3,1.072.577,2.149.869,3.222a2.99,2.99,0,0,0,4.553,1.912c.935-.521,1.855-1.07,2.782-1.607a1.977,1.977,0,0,1,2.778.353q2.1,2.093,4.183,4.2a1.915,1.915,0,0,1,.322,2.575c-.548.969-1.119,1.925-1.666,2.894a2.982,2.982,0,0,0,1.924,4.548c1.074.29,2.151.569,3.222.869a1.918,1.918,0,0,1,1.56,2.014c.017,2.038.005,4.077.005,6.177h-1.866v-2.39c0-1.114-.029-2.229.013-3.342.019-.507-.174-.7-.634-.8-.98-.231-1.951-.5-2.922-.771a4.83,4.83,0,0,1-3.007-7.074c.521-.959,1.1-1.886,1.621-2.847a.7.7,0,0,0-.005-.633c-1.4-1.448-2.833-2.869-4.289-4.329-1.024.59-2.019,1.165-3.015,1.737a4.84,4.84,0,0,1-7.363-3.034c-.268-.971-.543-1.941-.778-2.92a.512.512,0,0,0-.6-.466c-1.829.015-3.658.018-5.486,0a.555.555,0,0,0-.642.5c-.246,1-.515,1.991-.783,2.983a4.825,4.825,0,0,1-7.089,3.068c-.98-.525-1.926-1.115-2.9-1.644a.628.628,0,0,0-.576.032C123.353,171.209,121.931,172.637,120.468,174.093Z",
    transform: "translate(-0.072 0)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M234.1,501.523l-.715-1.762c.578-.305,1.136-.583,1.674-.895.162-.094.38-.284.381-.432a37.583,37.583,0,0,0-.06-4.09,5.348,5.348,0,0,0-2.7-4.062,27.513,27.513,0,0,0-3.575-1.666,1.032,1.032,0,0,0-.707.067,11.22,11.22,0,0,1-8.885.008,1.278,1.278,0,0,0-.773-.071,11.059,11.059,0,0,0-3.983,1.959,5.8,5.8,0,0,0-2.353,4.6c-.019.987-.041,1.976.006,2.961a1.074,1.074,0,0,0,.436.725,17.935,17.935,0,0,0,1.652.887l-.725,1.77c-1-.588-1.955-1.129-2.883-1.715a.8.8,0,0,1-.3-.592,44.413,44.413,0,0,1,.1-5.286,7.318,7.318,0,0,1,4.021-5.563,29.6,29.6,0,0,1,4.111-1.7,1.391,1.391,0,0,1,.961.1,9.361,9.361,0,0,0,8.331-.013,1.371,1.371,0,0,1,.845-.119,12.843,12.843,0,0,1,6.03,3.1,7.387,7.387,0,0,1,2.328,5.339c.023,1.3.033,2.607-.014,3.907a1.271,1.271,0,0,1-.43.905C236.009,500.474,235.081,500.959,234.1,501.523Z",
    transform: "translate(-84.484 -282.746)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M272.335,369.469a7.453,7.453,0,1,1-7.437-7.487A7.439,7.439,0,0,1,272.335,369.469Zm-1.849.086a5.6,5.6,0,1,0-5.709,5.5A5.643,5.643,0,0,0,270.486,369.555Z",
    transform: "translate(-125.432 -173.846)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M218.86,275.526l-1.7-.253a12.575,12.575,0,0,1,11.277-10.725,12.793,12.793,0,0,1,13.881,10.71l-1.8.28a11.045,11.045,0,0,0-4.749-7.339,10.911,10.911,0,0,0-6.3-1.846A11.087,11.087,0,0,0,218.86,275.526Z",
    transform: "translate(-90.244 -88.654)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M131.107,448.934l-1.086,1.33c-.894-.406-1.7-.8-2.534-1.132a1.27,1.27,0,0,0-.834.022,8.449,8.449,0,0,1-6.155-.02.964.964,0,0,0-.657-.052,16.54,16.54,0,0,0-2.51,1.271,3.663,3.663,0,0,0-1.609,3.372,4.2,4.2,0,0,1,0,.944c-.163.875.292,1.268,1.032,1.575a18.556,18.556,0,0,0,6.141,1.245c.168.01.336.014.5.026a.625.625,0,0,1,.145.061v1.773a18.916,18.916,0,0,1-5.73-.789,30.489,30.489,0,0,1-3.275-1.43,1.128,1.128,0,0,1-.667-1.177c.033-.818.02-1.639.01-2.459a5.339,5.339,0,0,1,2.549-4.785,19.911,19.911,0,0,1,3.415-1.549,1.355,1.355,0,0,1,.955.071,6.46,6.46,0,0,0,5.6-.006,1.594,1.594,0,0,1,.96-.07A9.329,9.329,0,0,1,131.107,448.934Z",
    transform: "translate(0 -248.219)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M390.247,459.134V457.32c1.292-.157,2.557-.216,3.776-.486a34.184,34.184,0,0,0,3.518-1.136.7.7,0,0,0,.514-.816,10.325,10.325,0,0,1-.006-1.385,4.072,4.072,0,0,0-2.133-3.805c-.336-.211-.706-.369-1.061-.549a2.5,2.5,0,0,0-2.153-.116,7.452,7.452,0,0,1-5.3-.062,1.768,1.768,0,0,0-1.5.011c-.692.34-1.384.679-2.131,1.045l-1.107-1.35a9.4,9.4,0,0,1,4.087-1.867,1.185,1.185,0,0,1,.655.165,6.412,6.412,0,0,0,5.542.007,1.7,1.7,0,0,1,1.016-.08,9.294,9.294,0,0,1,3.669,1.733,5.708,5.708,0,0,1,2.277,4.569c.018.819-.008,1.638.007,2.457a1.3,1.3,0,0,1-.658,1.2,14.077,14.077,0,0,1-5.912,2C392.335,458.987,391.312,459.039,390.247,459.134Z",
    transform: "translate(-234.854 -247.95)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M152.487,369.958a5.5,5.5,0,0,1-5.466-5.647,5.539,5.539,0,1,1,11.075.273A5.5,5.5,0,0,1,152.487,369.958Zm.085-1.867a3.651,3.651,0,0,0,3.668-3.622,3.68,3.68,0,1,0-7.36-.043A3.65,3.65,0,0,0,152.571,368.09Z",
    transform: "translate(-28.964 -171.133)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M403.875,370a5.462,5.462,0,0,1-5.447-5.643A5.532,5.532,0,1,1,403.875,370Zm.059-1.865a3.683,3.683,0,0,0,3.7-3.67,3.691,3.691,0,1,0-7.381.047A3.681,3.681,0,0,0,403.934,368.133Z",
    transform: "translate(-248.628 -171.174)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M264.446,562.615h1.81c0,.347.012.653,0,.958-.064,1.385-.144,2.77-.2,4.155a.987.987,0,0,1-.849,1.014,31.236,31.236,0,0,1-14.787,0,.961.961,0,0,1-.843-.893c-.1-1.717-.161-3.435-.241-5.217h1.839c.066,1.262.159,2.535.187,3.809.011.5.181.669.663.762a29.9,29.9,0,0,0,11.705-.027c.441-.089.532-.288.546-.671C264.319,565.21,264.387,563.914,264.446,562.615Z",
    transform: "translate(-118.358 -349.148)",
    fill: "#0b2ff7",
    stroke: "#0b2ff7",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.96288c23fb6f27a5411736658002ed1a.svg";
export { ForwardRef as ReactComponent };